<script lang="ts" setup>
import { useClassroomLearningPlatform } from '@hooks/classroom/learning-platform.hook'

import LessonRoomControlButton from '@Atoms/LessonRoom/LessonRoomControlButton.vue'

defineOptions({
  name: 'ButtonLearningPlatform',
})

const {
  label,
  isVisible,
  handleClick,
} = useClassroomLearningPlatform()
</script>

<template>
  <LessonRoomControlButton
    v-if="isVisible"
    :icon="{ name: 'puzzle-piece' }"
    :label="label"
    wrap-label
    @click="handleClick"
  />
</template>
